import { Project } from '@greenkub-fronts/shared/interface';

export interface AddressProps {
  project: Project;
}

export const AddressPdfBloc = (props: AddressProps) => {
  const {
    project,
  } = props;

  return <>
    <span>À l'attention de&nbsp;:</span>
    <ul>
      {project.addressInvoice ? (
        <>
          <li>
            <strong>{project.addressInvoice.identity}</strong>
          </li>
          <li>
            {project.addressInvoice.address.street}
            {project.addressInvoice.address.street2 && <>
              <br />{project.addressInvoice.address.street2}
            </>}
            <br />
            {project.addressInvoice.address.postalCode + ' ' +
              project.addressInvoice.address.city}
          </li>
        </>
      ) : (
        <>
          <li>
            <strong>
              {project.customer.firstName}{' '}
              {project.customer.lastName}
            </strong>
          </li>
          {project.customer.userRelated && (
            <li>
              <strong>
                {project.customer.userRelated.firstName}{' '}
                {project.customer.userRelated.lastName}
              </strong>
            </li>
          )}
          <li>
            {project.customer.address.street}
            {project.customer.address.street2 && <>
              <br />{project.customer.address.street2}
            </>}
            <br />
            {project.customer.address.postalCode + ' ' +
              project.customer.address.city}
          </li>
        </>
      )}
      <li>
        Email&nbsp;: <span>{project.customer.email}</span>
      </li>
      <li>
        Téléphone&nbsp;:{' '}
        <span>
          {project.customer.phone
            ? project.customer.phone
            : project.customer.mobile}
        </span>
      </li>
      {project.addressInvoice &&
        (project.addressInvoice.tvaNumber?.length || 0) > 0 &&
        <li>TVA&nbsp;: {project.addressInvoice.tvaNumber}</li>
      }
    </ul>
  </>;
};
